import './css/subcategory.css';


import AnimeShapes1 from './images/products/1.jpg';
import AnimeShapes2 from './images/products/2.jpg';
import AnimeShapes3 from './images/products/3.jpg';



function SubCategory(){
    return(
        <>
            <h1 class="cat-header">منتجات يابانية</h1>



                <section class="products-category">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="category">
                            <div class="products row">
                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                        <img src={AnimeShapes3} alt="animeproduct"/>
                                        <h1> مكياج أحلى ساكورا </h1>
                                        <div className="price">
                                            <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                        </div>

                                        
                                        <div className="discount">
                                            <span className="old-price">900</span>
                                            <span className="discount-range">18%</span>
                                        </div>

                                        <div className="rate">
                                            <span className="number">(46)</span>
                                            <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                        </div>
                                        <a href="item.html"> المزيد </a>
                                    </div>
                                </div>




                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes1} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>




                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes1} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>






                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes3} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>
                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes1} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>


                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes1} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>


                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes2} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>


                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes3} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>


                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes1} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>


                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes2} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>



                                

                                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div class="product">
                                            <img src={AnimeShapes3} alt="animeproduct"/>
                                            <h1> مكياج أحلى ساكورا </h1>
                                            <div className="price">
                                                <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                            </div>

                                            
                                            <div className="discount">
                                                <span className="old-price">900</span>
                                                <span className="discount-range">18%</span>
                                            </div>

                                            <div className="rate">
                                                <span className="number">(46)</span>
                                                <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                            </div>
                                            <a href="item.html"> المزيد </a>
                                        </div>
                                </div>




                            </div>
                        </div>
                        </div>
                    </div>
                </section>

        </>
    )
}

export default SubCategory;